import styled from 'styled-components'

export const StContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space4};

  @media (min-width: ${({ theme }) => theme.UI.BreakpointPx.Desktop}) {
    flex-direction: row;
    gap: ${({ theme }) => theme.UI.SpacingPx.Space10};
  }
`

export const StContainerDoubleColumns = styled(StContainer)`
  @media (min-width: ${({ theme }) => theme.UI.BreakpointPx.Tablet}) {
    flex-direction: row;
    gap: ${({ theme }) => theme.UI.SpacingPx.Space10};
  }
`

export const StColumn = styled.div`
  flex: 1;
`
